import { render, staticRenderFns } from "./AutoImportTags.vue?vue&type=template&id=a6807340&scoped=true"
import script from "./AutoImportTags.vue?vue&type=script&lang=js"
export * from "./AutoImportTags.vue?vue&type=script&lang=js"
import style0 from "./AutoImportTags.vue?vue&type=style&index=0&id=a6807340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6807340",
  null
  
)

export default component.exports